
import { showFirstName } from '@/models/filters'

export default {
  filters: {
    showFirstName,
  },
  props: {
    user: {
      type: Object,
      default() {},
    },
    img: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: 'text-[#595959]',
    }
  },
  data() {
    return {
      isDropdownOpen: false,
    }
  },
  computed: {
    requiredDocuments() {
      return localStorage.required_documents
    },
  },
  methods: {
    perfilToPtBr(perfil) {
      const perfils = new Map([
        ['student', ''],
        ['professor', 'Professor'],
        ['coordinator', 'Coordenador'],
      ])
      return perfils.get(perfil)
    },
    logout() {
      this.$store.dispatch('credential/clearToken')
      location.reload()
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
  }
}
